import React from 'react';
import { Stack, StackItem, Text } from '@fluentui/react';

interface IPrivacyPolicyComponentProps {};

const PrivacyPolicyComponent = (props: IPrivacyPolicyComponentProps) => {
    return (
        <Stack>
            <StackItem>
                <Text 
                    variant="large"
                    className='fw-bold'>
                    Política de Privacidad
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    I. INFORMACIÓN EN CUMPLIMIENTO DE LO ESTABLECIDO EN LA LEY 34/2002, DE 11 DE JULIO, DE SERVICIOS DE LA SOCIEDAD DE LA INFORMACIÓN Y DE 
                    COMERCIO ELECTRÓNICO
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    En cumplimiento de lo establecido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de 
                    Comercio Electrónico (en adelante, LSSI-CE), se informa de modo expreso, preciso e inequívoco, tanto a los destinatarios del servicio como a 
                    los órganos competentes, de los siguientes aspectos relativos al prestador de servicios de la sociedad de la información:
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    NOMBRE / DENOMINACIÓN SOCIAL:
                </Text> <Text>
                    AMEDIDA TI S.L. CIF / NIF B-73374316 ACTIVIDAD / OBJETO SOCIAL Consultoría informática, software, sistemas y formación.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    DOMICILIO SOCIAL / PROFESIONAL:
                </Text> <Text>
                    C/ Antonio Machado, 51, Local 2. (30565) Las Torres de Cotillas. (MURCIA) TELÉFONO 968 387 397
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    DIRECCIÓN DE CORREO ELECTRÓNICO:
                </Text> <Text>
                    info@AMEDIDATI.com
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    DIRECCIÓN WEB:
                </Text> <Text>
                    www.AMEDIDATI.com
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    DATOS DE INSCRIPCIÓN EN EL REGISTRO MERCANTIL / REGISTRO PÚBLICO:
                </Text> <Text>
                    Registro Mercantil de Murcia, Tomo 22413, Folio 128, MU-52564. Sistema de Protección de Datos de Carácter Personal, en cumplimiento de la 
                    Ley Orgánica 15/1999, de 13 de diciembre, y el Real decreto 1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo 
                    de la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    II. INFORMACIÓN EN CUMPLIMIENTO DE LO ESTABLECIDO EN LA LEY ORGÁNICA DE PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    1. PRINCIPIO DE INFORMACIÓN
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    En cumplimiento de lo establecido en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter 
                    Personal (en adelante, LOPD), le informamos de modo expreso, preciso e inequívoco que los datos facilitados por usted a través de los 
                    formularios dispuestos al efecto en nuestra página web o en cualquier otro canal de recogida de los mismos, así como los que se generen 
                    durante su relación con nuestra entidad, serán objeto de tratamiento en los ficheros responsabilidad de AMEDIDA TI S.L., debidamente 
                    notificados en el Registro General de la Agencia Española de Protección de Datos, con la finalidad del mantenimiento y cumplimiento de la 
                    relación del destinatario del servicio con nuestra entidad y prestación de servicios derivada de la misma. Así mismo, en cumplimiento de lo 
                    establecido en la citada LOPD y en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico 
                    (en adelante, LSSI-CE), le informamos que sus datos podrán ser utilizados con la finalidad de enviarle comunicaciones comerciales y de 
                    cortesía relacionadas con nuestra entidad a través del teléfono, correo postal ordinario, fax, correo electrónico o medios de comunicación 
                    electrónica equivalentes. De igual manera, le informamos que sus datos serán cedidos en todos aquellos casos en que sea necesario para el 
                    desarrollo, cumplimiento y control de la relación del destinatario del servicio con nuestra entidad o en los supuestos en que lo autorice 
                    una norma con rango de ley y, en particular, cuando concurra uno de los supuestos siguientes: a) El tratamiento o la cesión tengan por 
                    objeto la satisfacción de un interés legítimo del responsable del tratamiento o del cesionario amparado por dicha norma; b) El tratamiento o 
                    la cesión de los datos sean necesarios para que el responsable del tratamiento cumpla un deber que le imponga dicha norma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    2. PRINCIPIO DEL CONSENTIMIENTO
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El consentimiento para el tratamiento de sus datos con las finalidades descritas en el apartado anterior se entenderá prestado a través de 
                    la marcación de la casilla correspondiente dispuesta al efecto en nuestra página web.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    3. CARÁCTER OBLIGATORIO DE LOS DATOS SOLICITADOS
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    La cumplimentación de todos y cada uno de los campos que aparecen en los formularios dispuestos al efecto en nuestra página web tiene 
                    carácter obligatorio (en caso contrario, aparecerán marcados con un asterisco los campos que tengan carácter obligatorio). La negativa a 
                    facilitar sus datos llevaría aparejada la imposibilidad del mantenimiento y cumplimiento de la relación del destinatario del servicio con 
                    nuestra entidad, ya que los mismos son necesarios para la prestación de servicios derivada de la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    4. PRINCIPIO DE CALIDAD DE LOS DATOS
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El destinatario del servicio será el único responsable de la veracidad y exactitud de los datos aportados, actuando AMEDIDA TI S.L. de buena 
                    fe como mero prestador del servicio. En el supuesto de que el destinatario del servicio facilite datos falsos o de terceras personas sin 
                    mediar su consentimiento para ello, responderá personalmente frente a AMEDIDA TI S.L., los afectados o interesados, Agencia Española de 
                    Protección de Datos y, en su caso, autoridades autonómicas de protección de datos, de las responsabilidades derivadas de dicha circunstancia.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Sistema de Protección de Datos de Carácter Personal, en cumplimiento de la Ley Orgánica 15/1999, de 13 de diciembre, y el Real decreto 
                    1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo de la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    AMEDIDA TI S.L. no recoge datos de personas menores de catorce años a través de su página web. En el supuesto de que una persona menor de 
                    catorce años facilite sus datos a través de los formularios dispuestos al efecto en nuestra página web o en cualquier otro canal de recogida 
                    de los mismos, se procederá a su destrucción inmediata en el mismo momento en que se tenga conocimiento de tal circunstancia.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Con la finalidad de dar cumplimiento a lo establecido en el artículo 4.3 de la LOPD, el destinatario del servicio se compromete a comunicar 
                    a AMEDIDA TI S.L. los cambios que se produzcan en sus datos, de forma que respondan con veracidad a su situación actual en todo momento.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    5. HERRAMIENTAS DE SEGUIMIENTO DE LA NAVEGACIÓN
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    Nuestra página web puede utilizar herramientas de seguimiento de la navegación a través de la misma y dirección IP del destinatario del 
                    servicio, con la finalidad de mejorar y garantizar la prestación de servicios y el funcionamiento técnico de la misma.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    6. PRINCIPIO DE SEGURIDAD DE LOS DATOS
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    AMEDIDA TI S.L. se compromete al cumplimiento de su obligación de secreto respecto de los datos de carácter personal y de su deber de 
                    guardarlos y adoptará todas las medidas de índole técnica y organizativa necesarias que garanticen la seguridad de los datos de carácter 
                    personal y eviten su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de 
                    los datos almacenados y los riesgos a que estén expuestos, ya provengan de la acción humana o del medio físico o natural, desarrolladas en 
                    el Título VIII del Real Decreto 1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo de la Ley Orgánica 15/1999, 
                    de 13 de diciembre, de Protección de Datos de Carácter Personal.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    7. EJERCICIO DE DERECHOS
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    En cumplimiento de lo establecido en la LOPD y el Real Decreto 1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de 
                    desarrollo de la misma, el destinatario del servicio puede ejercitar, en cualquier momento, sus derechos de acceso, rectificación, 
                    cancelación y oposición ante el responsable del fichero o del tratamiento, adjuntando fotocopia de su DNI.
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text className='fw-bold'>
                    8. RESPONSABLE DEL FICHERO O DEL TRATAMIENTO
                </Text>
            </StackItem>
            <StackItem className='mt-3'>
                <Text>
                    El responsable del fichero o del tratamiento es AMEDIDA TI S.L. , con dirección a efectos de notificaciones en C/ Antonio Machado, 51, Local 
                    2. (30565) Las Torres de Cotillas. (MURCIA)
                </Text>
            </StackItem>
        </Stack>
    );
};

export default PrivacyPolicyComponent;
